import React, { useMemo, Component } from "react";
import { Navigation } from 'swiper';
// Pagination, Scrollbar, A11y
import { Swiper, SwiperSlide } from "swiper/react";

//import  cursoByOrder  from "./itemCursoByOptions"

import curso from "./cursos/competencias_2026.json"
import facultades from "./cursos/facultades.json";
import dataLic from "./cursos/licenciaturas.json";


import 'swiper/css';
import 'swiper/css/navigation';
//import 'swiper/css/pagination';
//import 'swiper/css/scrollbar';


function ItemCursosO(props) {


    const tieneOpciones = props?.item[0]?.opcion;

    if (tieneOpciones) {
        return (
            <div className="table-item-couser">

                <div className="card card-item mb-3">
                    <div className="header-table-options">
                        {props.item[0].opcion}
                    </div>
                </div>


                {props.item.map((curso, index) => (

                    <div className="card card-item my-2" key={`curso-${curso.id_curso}-${index}`}>
                        <div className="card-header" style={{ backgroundColor: "#6546ea;", color: "#fff;" }}>
                            <h4 className="card-title">{curso.programa}</h4>
                        </div>

                        <div className="card-body">

                            <div className="card-text-left">
                                <div><strong>Clave:</strong></div>
                                <div>{curso.id_curso}</div>
                            </div>

                            <div className="card-text-rigth">
                                <div><strong>Horas:</strong></div>
                                <div>{curso.horas}</div>
                            </div>

                        </div>

                    </div>

                ))}
            </div>


        );
    }
    return (
        <>



            {props.item.map((item, index) => {

                return (
                    <div className="table-item-couser">
                        <div className="card card-item my-2" key={`curso-${item.id_curso}-${index}`}>

                            <div className="card-header" style={{ backgroundColor: "#6546ea;", color: "#fff;" }}>
                                <h4 className="card-title">
                                    {item.programa}
                                </h4>
                            </div>

                            <div className="card-body">

                                <div className="card-text-left">
                                    <div><strong>Clave:</strong></div>
                                    <div>{item.id_curso}</div>
                                </div>

                                <div className="card-text-rigth">
                                    <div><strong>Horas:</strong></div>
                                    <div>{item.horas}</div>
                                </div>

                            </div>

                        </div> </div>
                );
            })}


        </>
    );
}
function ItemSlider(props) {

    const cursosFiltrados = props.curso.filter(
        (curso) => parseInt(curso.id_licenciatura) === parseInt(props.id)
    );

    return (
        <>
            {
                cursosFiltrados.map((cur, index) => {
                    const info = getCursosInfo(cur.cursos);
                    const getMensaje = (info) => {
                        const { totalCursos, totalOpciones } = info;

                        let tipo = "default";

                        if (totalCursos === 4 && totalOpciones === 2) {
                            tipo = "4_cursos_2_opciones"; 
                        }
                        else if (totalCursos === 2 && totalOpciones === 0) {
                            tipo = "2_cursos";
                        }
                        else if (totalOpciones === 2) {
                            tipo = "2_opciones";
                        }
                        else if (totalOpciones === 3) {
                            tipo = "3_opciones";
                        }
                        else if (totalOpciones === 4) {
                            tipo = "4_opciones";
                        }

                        switch (tipo) {

                            case "2_cursos":
                                return "Para acreditar el Bloque 2, deberás seleccionar ambos cursos. Recuerda que puedes inscribir el NRC o la clave de la materia.";

                            case "2_opciones":
                                return "Para acreditar el Bloque 2, deberás seleccionar una de las siguientes opciones. Recuerda que puedes inscribir el NRC o la clave de la materia.";

                            case "4_cursos_2_opciones":
                                return "Para acreditar el Bloque 2, deberás seleccionar una de las siguientes opciones (2 cursos). Recuerda que puedes inscribir el NRC o la clave de la materia.";

                            case "3_opciones":
                                return "Para acreditar el Bloque 2, deberás seleccionar una de las siguientes opciones. Recuerda que puedes inscribir el NRC o la clave de la materia.";

                            case "4_opciones":
                                return "Para acreditar el Bloque 2, deberás seleccionar una de las siguientes opciones. Recuerda que puedes inscribir el NRC o la clave de la materia.";

                            default:
                                return "Para acreditar el Bloque 2, deberás seleccionar la siguiente opción. Recuerda que puedes inscribir el NRC o la clave de la materia.";
                        }
                    };

                    return (
                        <div className="row py-0" key={`${cur.id_licenciatura}-${index}`}>
                            <div className={` ${info.totalCursos > 2 && info.totalOpciones > 2 ? "col-12 col-md-12" : "col-12 col-md-6"} `}>

                                <div className={` ${info.totalCursos > 2 && info.totalOpciones > 2 ? "licenciatura-table-2" : "licenciatura-table"} `}>
                                    <HeaderTitle licenciatura={cur.licenciatura} facultad={cur.facultad} />
                                    <div className="notice-info-cursos"><p style={{ fontSize: 16 + "px" }}><i>*{getMensaje(info)} </i></p></div>
                                    <CursoTabla key={`tabla-${cur.id_licenciatura - cur.licenciatura}`} cursosItems={cur.cursos} id={props.id} isOptions={props.isOption} isCombo={`${info.totalOpciones > 2 && info.tieneOpciones == "true" ? "true" : "false"}`} />
                                </div>
                            </div>

                            <div className={` ${info.totalCursos > 2 && info.totalOpciones > 2 ? " d-none" : "col-12 col-md-6"} `}>
                                <div className="licenciatura-image">
                                    <img
                                        className="img-fluid"
                                        src={props.getImage(props.portada)}
                                        alt={cur.licenciatura}
                                    />
                                </div>
                            </div>

                        </div>
                    )
                })
            }
        </>
    )
}

function CursoTabla(props) {
    // const isOptions = props.isOption;

    return (
        <>
            <div className="table-grid-wrapper">

                {
                    Object.keys(props.cursosItems).map((cur, index) => (

                        <ItemCursosO key={`item-curso-id-${index}`} index={index} item={props.cursosItems[cur]} />
                    ))
                }

            </div>
        </>

    );
}
const getCursosInfo = (cursos = {}) => {

    let totalCursos = 0;
    let totalOpciones = 0;
    let soloOtros = true;

    for (const key in cursos) {

        const arr = cursos[key] || [];

        totalCursos += arr.length;

        if (key.startsWith("opcion")) {
            totalOpciones++;
            soloOtros = false;
        }

        if (key !== "otros") {
            soloOtros = false;
        }
    }

    return {
        totalCursos,
        totalOpciones,
        tieneOpciones: totalOpciones > 2,
        soloOtros
    };

};
function OptionoptFaces(props) {
    return (
        <option value={props.fac.id_facultad}>{props.fac.facultad}</option>
    )
}
function OptionsLicenciatura(props) {
    return (
        <option value={props.lic.id_licenciatura}>{props.lic.licenciatura}</option>
    )
}
function HeaderTitle(props) {
    return (
        <div className="header-licenciatura py-4 text-start">
            <h4 className="title-facultad-header">{props.facultad}</h4>
            <h2 className="title-licencituras-header"> Lic. {props.licenciatura}</h2>
        </div>
    );
}

export default class Cursos extends Component {


    constructor(props) {
        super(props);

        this.state = {
            optFac: 0,
            optLic: 0,
            countitem: 0,
            curso: curso,
            licenciaturas: dataLic.data,

        }
        this.SelectOptions = this.SelectOptions.bind(this);
        this.updateLic = this.updateLic.bind(this);
        this.UpdateDateId = this.UpdateDateId.bind(this);
    }
    SelectOptions(e) {
        this.setState({
            optFac: e.target.value
        });
    }
    updateLic(e) {
        this.setState({
            optLic: e.target.value
        });
    }

    getImage(portada) {
        return `https://www.anahuac.mx/competencias-digitales/sites/default/files/img/Licenciaturas/${portada}`
    }

    UpdateDateId() {
        if (this.state.optFac !== 0 && this.state.optLic === 0) {
            this.setState({
                licenciaturas: dataLic.data.filter((item) => Number(item.id_facultad) === Number(this.state.optFac))
            })
        }
        this.setState({
            licenciaturas: dataLic.data
        })
    }
    render() {

        return (
            <div>

                <div className="container-fluid justify-content-center">
                    <div className="row justify-content-center my-0 py-0">
                        <div className="col-12 col-md-5 py-2">

                            <div className="anahuac-search-section  my-2">

                                <select name="selectedFacultad" defaultValue={this.state.optFac} onChange={this.SelectOptions} className="form-select form-control " aria-label="Default select example">
                                    <option value="0">Selecciona tu Facultad</option>
                                    {facultades.facultades.map(fac => (
                                        <OptionoptFaces key={fac.id_facultad} fac={fac} />
                                    ))
                                    }
                                </select>
                            </div>

                        </div>
                        <div className="col-12 col-md-5  py-2">
                            <div className="anahuac-search-section my-2">
                                <select name="selectedLicenciatura" defaultValue={this.state.optLic} onChange={this.updateLic} className="form-select form-control" aria-label="Default select example">
                                    <option value="0">Selecciona tu Licenciatura</option>
                                    {this.state.licenciaturas.filter((lic) => Number(lic.id_facultad) === Number(this.state.optFac)).map((item) => (
                                        <OptionsLicenciatura key={item.id_licenciatura} lic={item} />
                                    ))
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <Swiper
                            modules={[Navigation]}
                            autoHeight={true}
                            spaceBetween={50}
                            slidesPerView={1}
                            navigation
                        >
                            {
                                this.state.licenciaturas.filter((lic) => Number(lic.id_licenciatura) === Number(this.state.optLic) || Number(this.state.optLic) === 0)
                                    .map((item, index) => (
                                        <SwiperSlide id={`item-slider-${item.id_licenciatura}`} key={`container-id-${item.id_licenciatura}`}>
                                            <ItemSlider key={`slider-id-${item.id_licenciatura}`} curso={this.state.curso} id={parseInt(item.id_licenciatura)} isOption={item.opciones} portada={item.portada} getImage={this.getImage} ></ItemSlider>
                                        </SwiperSlide>
                                    )
                                    )
                            }

                        </Swiper>
                    </div>
                </div>
            </div>
        )
    }
}